var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconInfo = function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.25a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm8 2.75A6.75 6.75 0 1 1 8 1.25 6.758 6.758 0 0 1 14.75 8Zm-1.5 0a5.25 5.25 0 1 0-10.5 0 5.25 5.25 0 0 0 10.5 0Zm-4.5 2.293V8.25A1.25 1.25 0 0 0 7.5 7a.75.75 0 0 0-.25 1.457V10.5a1.25 1.25 0 0 0 1.25 1.25.75.75 0 0 0 .25-1.457Z",
    fill: "#202931"
  })));
};

export default SvgIconInfo;